import { FC } from 'react';
import { Text } from '@mofid-securities/uikit';
import { registerSteps } from '../../constants';
import BottomSheet from '@/components/BottomSheet';
import Button from '@/components/Button';
import { Divider } from '@/components/Divider';
import { TRedirectData } from '../../types';

interface IDuplicatePhoneNumberBottomsheetProps {
  currentStepPayload: TRedirectData;
  handleRegisterLogic: (__data: TRedirectData) => void;
}

const DuplicatePhoneNumberBottomsheet: FC<
  IDuplicatePhoneNumberBottomsheetProps
> = ({ currentStepPayload, handleRegisterLogic }) => {
  const handleCtaAction = () => {
    const redirectData = {
      nextStep: registerSteps?.MofidOtp,
      requestToken: currentStepPayload?.requestToken,
    };
    handleRegisterLogic(redirectData);
    BottomSheet.close();
  };

  return (
    <div className="flex flex-col gap-y-4">
      <Text
        className="text-error-filled-primary-enabled"
        size="md"
        weight="demibold"
      >
        شماره موبایل تکراری
      </Text>
      <Text color="gray-120" size="sm" weight="regular">
        {currentStepPayload?.message?.message}
      </Text>
      <Divider />
      <div className="flex flex-col gap-y-2 md:flex-row md:gap-x-2">
        <Button
          analytics={['NEW_REG_CONTINUE_WITH_DUPLICATE_PHONE_NUMBER']}
          className="w-full md:w-1/2"
          isFullWidth
          onClick={handleCtaAction}
        >
          ادامه با شماره موبایل جدید
        </Button>
      </div>
    </div>
  );
};

export const openDuplicatePhoneNumberBottomsheet = (
  currentStepPayload: TRedirectData,
  handleRegisterLogic: (__data: TRedirectData) => void
) => {
  return BottomSheet.open({
    children: (
      <DuplicatePhoneNumberBottomsheet
        currentStepPayload={currentStepPayload}
        handleRegisterLogic={handleRegisterLogic}
      />
    ),
    closeAction: () => {},
  });
};
